export const convertDateToString = time => {
	const timestampInMs = time?.seconds * 1000 + time?.nanoseconds / 1000000
	const date = new Date(timestampInMs)
	return date.toUTCString()
}
